/* ==========================================================================
   NUA DREAMS — cesta.js
   La cesta, contra la API de Shopify.

   La regla de este archivo es que aquí NO se calcula nada. Ni el subtotal, ni
   el IVA, ni los descuentos, ni lo que falta para el envío gratis. Todo eso lo
   cuenta el servidor y llega ya escrito: se pide /cart/add.js,
   /cart/change.js o /cart/update.js con el parámetro `sections`, Shopify
   devuelve la sección sections/cesta-cajon.liquid pintada de nuevo y aquí
   sólo se sustituye lo que hay dentro del panel.

   Es más código que sumar precios a mano, pero es la única manera de que lo
   que dice el cajón y lo que cobra la pasarela no puedan separarse nunca: una
   promoción, un impuesto o un precio por país cambian en un sitio, no en dos.

   Lo mismo con las frases: ninguna se escribe aquí. Las del código de
   descuento vienen en atributos data- del cajón, escritas por Liquid, y lo
   único que se hace es poner el código en su __CODIGO__. Los errores son el
   motivo que da Shopify, tal cual, o la frase genérica de locales/.

   Abrir y cerrar el cajón no está aquí: lo reparte cajones.js a partir de
   data-accion="abrir-cesta" / "cerrar-cesta".

   Lo que se puede usar desde fuera (la ficha de producto, por ejemplo):

     NuaCesta.anadir(id, cantidad, boton)            una variante
     NuaCesta.anadir([{id, quantity}, …], 0, boton)  varias en una petición
                                                     (la ficha manda así la
                                                     vela y sus complementos)

   Y sin una línea de JavaScript, desde el marcado:

     <button data-cesta-anadir="ID_DE_VARIANTE">          añade una
     <form data-cesta-rapido> con <input name="id">       el «+» de la tarjeta;
                                                          sin JS va a /cart/add
   ========================================================================== */

var NuaCesta = (function () {

  var SECCION = "cesta-cajon";
  var temporizador = null;

  /* ---------- Piezas del DOM ---------------------------------------------- */

  function cajon()     { return document.querySelector("[data-cesta]"); }
  function contenido() { return document.querySelector("[data-cesta-contenido]"); }
  function boton()     { return document.querySelector("[data-cesta-boton]"); }

  function abrir(disparador) {
    NuaCajon.abrir(cajon(), disparador || boton());
  }

  /* ---------- Errores ------------------------------------------------------ */

  /* Lo que se enseña cuando algo sale mal. Si el error viene de Shopify
     (NuaSitio.pedir lo marca con `tienda`), su texto es el motivo de verdad:
     «Tu carrito ya tiene la cantidad máxima de este artículo». Si es otra
     cosa, la frase genérica: el texto de un error de programación no es para
     la clienta. */
  function motivo(error) {
    return error && error.tienda && error.message ? error.message : NuaSitio.textos.cestaError;
  }

  /* El aviso va en el <p role="alert"> de debajo de la cabecera del cajón,
     que está fuera de lo que se repinta. Si el cajón está cerrado —el «+» de
     una tarjeta de la portada— se abre: el aviso tiene que verse, no sólo
     oírse. Se abre ANTES de escribirlo, porque al abrirse se borra el aviso
     que hubiera de la vez anterior. */
  function mostrarError(mensaje, disparador) {
    var caja = document.querySelector("[data-cesta-error]");
    var panel = cajon();
    if (!caja || !panel) {
      NuaSitio.anunciar(mensaje);
      return;
    }
    if (panel.hidden) abrir(disparador);

    /* Vacío primero y el texto un instante después: si es el mismo que ya
       estaba, un lector de pantalla no lo vuelve a leer. */
    caja.textContent = "";
    caja.hidden = false;
    window.setTimeout(function () { caja.textContent = mensaje; }, 60);
  }

  function limpiarError() {
    var caja = document.querySelector("[data-cesta-error]");
    if (!caja) return;
    caja.hidden = true;
    caja.textContent = "";
  }

  /* ---------- Repintado ---------------------------------------------------- */

  /* Sustituye el contenido del cajón por el que acaba de devolver Shopify y
     pone al día el contador de la cabecera. Se sustituye SÓLO el interior:
     el <div class="cajon"> de fuera es el que cajones.js tiene fichado como
     panel abierto, y cambiarlo entero dejaría esa referencia apuntando a un
     elemento que ya no está en la página.

     Lo que el HTML nuevo no puede saber se pasa del viejo al nuevo antes del
     cambio: hasta dónde se había desplazado el cuerpo, qué plegables estaban
     abiertos, lo que se estaba escribiendo y dónde estaba el cursor. Sin eso,
     un «+» devolvía la lista arriba del todo y se llevaba media nota escrita.

     `conservarError`: el repintado que se pide DESPUÉS de un error (para
     enseñar cómo ha quedado la cesta) no borra el aviso. */
  function repintar(html, carrito, conservarError) {
    var nuevo = NuaSitio.seccion(html, "[data-cesta-contenido]");
    var actual = contenido();
    if (!nuevo || !actual) return;

    var cuerpo = actual.querySelector(".cesta__cuerpo");
    var desplazado = cuerpo ? cuerpo.scrollTop : 0;

    var foco = document.activeElement;
    var escribiendo = foco && actual.contains(foco) && foco.id &&
      (foco.tagName === "INPUT" || foco.tagName === "TEXTAREA") ? foco : null;
    var gemelo = escribiendo ? nuevo.querySelector("#" + escribiendo.id) : null;
    if (gemelo) gemelo.value = escribiendo.value;

    /* La nota que aún no ha llegado al servidor manda sobre la que trae la
       respuesta, que se pintó antes de guardarla. */
    var nota = nuevo.querySelector("[data-cesta-nota]");
    if (nota && notaLocal !== null) nota.value = notaLocal;

    heredarPlegable(actual, nuevo, "[data-cesta-regalo]");
    heredarCodigo(actual, nuevo);

    actual.parentNode.replaceChild(nuevo, actual);

    var cuerpoNuevo = nuevo.querySelector(".cesta__cuerpo");
    if (cuerpoNuevo && desplazado) cuerpoNuevo.scrollTop = desplazado;

    if (gemelo) {
      var desde = escribiendo.selectionStart, hasta = escribiendo.selectionEnd;
      gemelo.focus({ preventScroll: true });
      try { gemelo.setSelectionRange(desde, hasta); } catch (e) {}
    }

    if (!conservarError) limpiarError();
    cabecera(nuevo);
    montarExpres(html);
    codigo(carrito);
    /* Aviso para quien necesite saber que la cesta ha cambiado (la ficha de
       producto recalcula cuántas unidades quedan por añadir). */
    document.dispatchEvent(new CustomEvent("nua:cesta-cambiada"));
  }

  function heredarPlegable(viejo, nuevo, selector) {
    var antes = viejo.querySelector(selector);
    var despues = nuevo.querySelector(selector);
    if (antes && despues && antes.open) despues.open = true;
  }

  /* El bloque del código llega del servidor escondido y sin filas: su estado
     sólo lo sabe /cart.js. Mientras llega, se queda como estaba, para que no
     desaparezca y vuelva a salir cada vez que se toca un «+». */
  function heredarCodigo(viejo, nuevo) {
    var antes = viejo.querySelector("[data-cesta-codigo]");
    var despues = nuevo.querySelector("[data-cesta-codigo]");
    if (!antes || !despues) return;
    despues.hidden = antes.hidden;
    despues.open = antes.open;

    var listaAntes = antes.querySelector("[data-cesta-codigo-lista]");
    var listaDespues = despues.querySelector("[data-cesta-codigo-lista]");
    var estadoAntes = antes.querySelector("[data-cesta-codigo-estado]");
    var estadoDespues = despues.querySelector("[data-cesta-codigo-estado]");
    if (listaAntes && listaDespues && estadoAntes && estadoDespues) {
      while (listaAntes.firstChild) listaDespues.appendChild(listaAntes.firstChild);
      estadoDespues.hidden = estadoAntes.hidden;
    }
  }

  /* Si la página se cargó con la cesta vacía, los botones de pago exprés están
     guardados en un <template> para que Shopify no los arranque en balde (ver
     cesta-cajon.liquid). La primera vez que la cesta tiene algo, se ponen en
     su sitio y Shopify, que se queda mirando si aparecen, los monta.

     Se usan los de la sección que acaba de llegar, no los del <template>: la
     lista de carteras la escribe Shopify en el servidor según la cesta, y con
     la cesta vacía deja fuera Google Pay. Pintados con algo dentro, la traen.
     Si la respuesta no los trae, valen los del <template>. */
  function montarExpres(html) {
    var molde = document.querySelector("template[data-cesta-expres]");
    if (!molde || cuenta() === 0) return;
    var fresco = html ? NuaSitio.seccion(html, ".cesta__expres") : null;
    molde.parentNode.replaceChild(fresco || molde.content, molde);
  }

  /* Vuelve a pedir el cajón tal como está la cesta ahora. Se usa después de
     un error: Shopify puede haber dejado la línea en lo que queda en vez de en
     lo que se pidió, y el cajón tiene que decir lo que hay de verdad. Sin
     cabecera Accept: con «application/json», en una ficha Shopify contesta
     con el producto en vez de con la sección. */
  function refrescar() {
    return fetch(window.location.pathname + "?sections=" + SECCION)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (datos) {
        if (datos && datos[SECCION]) repintar(datos[SECCION], null, true);
      })
      .catch(function () {});
  }

  /* Pone al día el icono de la cesta con lo que acaba de llegar del servidor.
     El número es decorativo (aria-hidden), así que la cuenta va también en la
     etiqueta del botón, que es lo que lee un lector de pantalla; y esa etiqueta
     viene ya escrita y en plural desde Liquid, no armada aquí. */
  function cabecera(caja) {
    var total = parseInt(caja.getAttribute("data-cesta-cuenta"), 10) || 0;
    var etiqueta = caja.querySelector("[data-cesta-etiqueta]");

    var contadores = document.querySelectorAll("[data-cesta-contador]");
    for (var i = 0; i < contadores.length; i++) {
      contadores[i].textContent = total;
      contadores[i].hidden = total === 0;
    }

    /* El pago exprés y la nota viven fuera de lo que se repinta (ver
       cesta-cajon.liquid): con la cesta vacía se esconden. */
    var remate = document.querySelector("[data-cesta-remate]");
    if (remate) remate.hidden = total === 0;

    if (!etiqueta) return;
    var botones = document.querySelectorAll("[data-cesta-boton]");
    for (var b = 0; b < botones.length; b++) {
      botones[b].setAttribute("aria-label", etiqueta.textContent.trim());
    }
  }

  /* La frase de «llevas tantas cosas», tal cual la escribió Liquid */
  function resumen() {
    var caja = contenido();
    var el = caja ? caja.querySelector("[data-cesta-resumen]") : null;
    return el ? el.textContent.trim() : "";
  }

  function cuenta() {
    var caja = contenido();
    return caja ? parseInt(caja.getAttribute("data-cesta-cuenta"), 10) || 0 : 0;
  }

  /* ---------- Acciones ----------------------------------------------------- */

  /* Añade una variante, o varias de golpe. Devuelve una promesa para que quien
     la llama —la ficha de producto— pueda enterarse de si ha ido mal y enseñar
     el motivo.

     El primer argumento puede ser el id de una variante o una lista de
     {id, quantity}: los complementos de la ficha van en la MISMA petición que
     la vela, así que o entran todos o no entra ninguno, y la cesta no se queda
     a medias con la mitad de lo que se pidió. */
  function anadir(idOLista, cantidad, disparador) {
    var items = Array.isArray(idOLista)
      ? idOLista
      : [{ id: idOLista, quantity: cantidad || 1 }];

    /* Se mira ANTES de repintar: después, el botón ya no está en la página. */
    var panel = cajon();
    var desdeElCajon = !!(disparador && panel && panel.contains(disparador));

    return NuaSitio.pedir(NuaSitio.rutas.anadir, {
      items: items,
      sections: [SECCION],
      sections_url: window.location.pathname
    }).then(function (datos) {
      if (datos.sections) repintar(datos.sections[SECCION]);

      NuaSitio.anunciar(NuaSitio.textos.anadido + " " + resumen());

      /* Si se ha añadido desde dentro del cajón (una sugerencia), el cajón ya
         está abierto y el botón pulsado acaba de desaparecer al repintar: el
         foco va al «+» de la línea nueva, que es donde está lo que se acaba
         de añadir. */
      if (desdeElCajon) {
        var clave = datos.items && datos.items[0] ? datos.items[0].key : null;
        devolverFoco(clave, "data-cesta-mas");
      } else if (window.Nua.abrirCestaAlAnadir !== false) {
        abrir(disparador);
      }
      return datos;
    });
  }

  /* Cambia la cantidad de una línea. `clave` es la key del line item, no el id
     de la variante: dos líneas pueden ser la misma variante con propiedades
     distintas (una con tarjeta escrita a mano y otra sin ella) y por id se
     tocarían las dos a la vez. */
  function poner(clave, cantidad, quienTeniaElFoco) {
    return NuaSitio.pedir(NuaSitio.rutas.cambiar, {
      id: clave,
      quantity: cantidad,
      sections: [SECCION],
      sections_url: window.location.pathname
    }).then(function (datos) {
      /* /cart/change.js devuelve la cesta entera, con sus códigos: se le pasa
         a repintar para que el estado del código no necesite otra petición. */
      if (datos.sections) repintar(datos.sections[SECCION], datos);
      devolverFoco(clave, quienTeniaElFoco);
      NuaSitio.anunciar(resumen());
      return datos;
    });
  }

  /* Repintar se lleva por delante el botón que se acaba de pulsar. Se apunta
     cuál era y se le devuelve el foco al que ocupa su sitio; si la línea entera
     ha desaparecido, el foco se va al aspa de cerrar, que es lo más parecido a
     «donde estabas». Tiene que ser el <button>, no el fondo, que lleva la misma
     acción y va antes en el HTML.

     preventScroll para que no se mueva la página, y luego se trae a la vista
     dentro del cuerpo del cajón, que es lo único que se desplaza: la línea
     nueva de una sugerencia puede haber caído fuera. */
  function devolverFoco(clave, marca) {
    if (!marca) return;

    var vuelta = clave ? document.querySelector("[" + marca + '="' + clave + '"]') : null;
    if (vuelta && !vuelta.disabled) {
      vuelta.focus({ preventScroll: true });
      if (vuelta.scrollIntoView) vuelta.scrollIntoView({ block: "nearest" });
      return;
    }
    var cierre = document.querySelector('button[data-accion="cerrar-cesta"]');
    if (cierre) cierre.focus({ preventScroll: true });
  }

  /* Los «+» y «−» de las líneas, con una cola por línea.

     Antes cada toque leía el número pintado y mandaba su petición, todas a la
     vez: dos «+» rápidos desde 1 leían los dos un 1 y pedían los dos un 2, y
     un «+» y un «−» rápidos podían llegar al revés y quitar la línea.

     Ahora cada línea apunta la cantidad a la que quiere llegar (`objetivo`) y
     sólo lleva una petición en vuelo a la vez (`enVuelo`). Los toques que
     llegan mientras tanto mueven el objetivo; al volver la respuesta, si el
     objetivo ya no es lo que se pidió, sale otra con el nuevo. «+ +» desde 1
     acaba en 3 y «+ −» en 1, pulses lo rápido que pulses.

     No se desactivan los botones mientras tanto: un toque durante la espera
     cuenta, que es lo que espera quien pulsa dos veces. */
  var objetivo = {};
  var enVuelo = {};

  function cantidadPintada(clave) {
    var linea = document.querySelector('[data-cesta-linea="' + clave + '"]');
    var valor = linea ? linea.querySelector(".cantidad__valor") : null;
    return valor ? parseInt(valor.textContent, 10) || 0 : null;
  }

  function ajustar(clave, delta, marca) {
    var base = objetivo.hasOwnProperty(clave) ? objetivo[clave] : cantidadPintada(clave);
    if (base === null) return;
    objetivo[clave] = Math.max(0, base + delta);
    if (!enVuelo[clave]) enviar(clave, marca);
  }

  function enviar(clave, marca) {
    var cantidad = objetivo[clave];
    enVuelo[clave] = true;

    poner(clave, cantidad, marca).then(function () {
      enVuelo[clave] = false;
      /* Con 0 la línea ya no existe: lo que se pulsara después no tiene
         dónde ir. */
      if (cantidad > 0 && objetivo[clave] !== cantidad) {
        enviar(clave, marca);
      } else {
        delete objetivo[clave];
      }
    }, function (error) {
      enVuelo[clave] = false;
      delete objetivo[clave];
      mostrarError(motivo(error));
      refrescar();
    });
  }

  /* ---------- Código de descuento ------------------------------------------ */

  /* El estado del código sale de la cesta de Shopify (/cart.js), que es la
     única que lo sabe: Liquid no ve los códigos guardados, sólo los que ya
     restan algo. Cada código llega como {code, applicable}:

       applicable: true   → «Código X aplicado»
       applicable: false  → o es de envío gratis (Shopify lo guarda y lo
                            aplica en la pasarela) o no vale para esta cesta.
                            La cesta no los distingue, así que decide la lista
                            de códigos de envío del ajuste del cajón.

     Puede haber varios a la vez (SITA y BIENVENIDA5). Las frases vienen
     escritas por Liquid en data-aplicado, data-pendiente, data-no-aplica y
     data-quitar-uno. Aquí sólo se elige una y se le pone el código, con
     textContent: lo que escribe la clienta nunca entra como HTML. */
  var codigoPedido = false;
  var codigoOcupado = false;

  function leerCesta() {
    return NuaSitio.pedir(NuaSitio.rutas.cesta + ".js");
  }

  /* Los códigos de una cesta, en mayúsculas y sin repetir */
  function codigosDe(carrito) {
    var lista = [];
    var codigos = (carrito && carrito.discount_codes) || [];
    for (var i = 0; i < codigos.length; i++) {
      var c = String(codigos[i].code || "").toUpperCase();
      if (c && lista.indexOf(c) === -1) lista.push(c);
    }
    return lista;
  }

  function bloqueCodigo() {
    var caja = contenido();
    return caja ? caja.querySelector("[data-cesta-codigo]") : null;
  }

  function codigo(carrito) {
    var bloque = bloqueCodigo();
    if (!bloque) return;
    codigoPedido = true;

    /* Sin JavaScript no se pinta: el marcado llega con hidden y se destapa
       aquí, en cada repintado. */
    bloque.hidden = false;

    if (carrito && carrito.discount_codes) {
      pintarCodigo(bloque, carrito.discount_codes);
      return;
    }
    leerCesta()
      .then(function (datos) {
        /* Si mientras tanto se ha repintado, el bloque ya es otro */
        var vigente = bloqueCodigo();
        if (vigente) pintarCodigo(vigente, datos.discount_codes || []);
      })
      .catch(function () {});
  }

  function mensajeCodigo(bloque, entrada) {
    var estado = bloque.querySelector("[data-cesta-codigo-estado]");
    if (!estado) return "";

    var envio = "," + (bloque.getAttribute("data-codigos-envio") || "").replace(/\s+/g, "") + ",";
    var plantilla;
    if (entrada.applicable) {
      plantilla = estado.getAttribute("data-aplicado");
    } else if (envio.indexOf("," + String(entrada.code).toUpperCase() + ",") !== -1) {
      plantilla = estado.getAttribute("data-pendiente");
    } else {
      plantilla = estado.getAttribute("data-no-aplica");
    }
    return (plantilla || "").split("__CODIGO__").join(String(entrada.code).toUpperCase());
  }

  /* Una fila por código, copiada del <template> que escribe Liquid: la frase
     y un «Quitar» que dice cuál quita («Quitar el código SITA»). */
  function pintarCodigo(bloque, codigos) {
    var estado = bloque.querySelector("[data-cesta-codigo-estado]");
    var lista = bloque.querySelector("[data-cesta-codigo-lista]");
    var molde = bloque.querySelector("template[data-cesta-codigo-molde]");
    if (!estado || !lista || !molde || !molde.content.firstElementChild) return;

    lista.textContent = "";
    if (!codigos.length) {
      estado.hidden = true;
      return;
    }

    var quitarUno = estado.getAttribute("data-quitar-uno") || "";
    for (var i = 0; i < codigos.length; i++) {
      var nombre = String(codigos[i].code).toUpperCase();
      var fila = molde.content.firstElementChild.cloneNode(true);
      var frase = fila.querySelector("[data-cesta-codigo-mensaje]");
      var quitar = fila.querySelector("[data-cesta-codigo-quitar]");
      if (frase) frase.textContent = mensajeCodigo(bloque, codigos[i]);
      if (quitar) {
        quitar.setAttribute("data-cesta-codigo-quitar", nombre);
        if (quitarUno) quitar.setAttribute("aria-label", quitarUno.split("__CODIGO__").join(nombre));
      }
      lista.appendChild(fila);
    }
    estado.hidden = false;
    /* Con un código puesto el bloque se abre solo: tiene que verse qué ha
       pasado con él sin ir a buscarlo. */
    bloque.open = true;
  }

  /* La frase de un código tal como ha quedado pintada, para leerla en voz alta */
  function fraseDe(nombre) {
    var bloque = bloqueCodigo();
    var botones = bloque ? bloque.querySelectorAll("[data-cesta-codigo-quitar]") : [];
    for (var i = 0; i < botones.length; i++) {
      if (botones[i].getAttribute("data-cesta-codigo-quitar") !== nombre) continue;
      var fila = botones[i].closest("li");
      var frase = fila ? fila.querySelector("[data-cesta-codigo-mensaje]") : null;
      return frase ? frase.textContent : "";
    }
    return "";
  }

  /* Cambia la lista de códigos de la cesta. Shopify guarda la lista que se le
     manda y borra el resto, así que primero se lee la que hay en /cart.js y
     se manda entera, con el nuevo añadido o con el quitado fuera. Antes se
     mandaba sólo el nuevo, y aplicar BIENVENIDA5 después de SITA borraba
     SITA sin avisar.

     Va por /cart/update.js con el parámetro `discount` (los códigos separados
     por comas), que devuelve la cesta y el cajón repintado en la misma
     respuesta. */
  function cambiarCodigos(cambio) {
    return leerCesta().then(function (carrito) {
      return NuaSitio.pedir(NuaSitio.rutas.actualizar + ".js", {
        discount: cambio(codigosDe(carrito)).join(","),
        sections: [SECCION],
        sections_url: window.location.pathname
      });
    });
  }

  function aplicarCodigo(texto) {
    /* En mayúsculas: Shopify no distingue y así el mensaje dice «SITA» y no
       «sita», igual que la línea del descuento. */
    var valor = String(texto || "").trim().toUpperCase();
    if (!valor) return Promise.resolve();

    return cambiarCodigos(function (lista) {
      if (lista.indexOf(valor) === -1) lista.push(valor);
      return lista;
    }).then(function (datos) {
      /* Si el código no ha quedado guardado, algo ha fallado por el camino:
         se dice, y el campo se queda como estaba para volver a intentarlo. */
      if (codigosDe(datos).indexOf(valor) === -1) throw NuaSitio.fallo();

      if (datos.sections) repintar(datos.sections[SECCION], datos);
      NuaSitio.anunciar(fraseDe(valor) || resumen());

      /* El foco vuelve al campo, que es donde estaba quien acaba de pulsar
         Intro o «Aplicar». El campo ya es el nuevo del repintado, y el
         plegable está abierto porque ya hay un código. Vacío: el repintado
         le copia lo escrito si tenía el foco, y ese código ya está puesto. */
      var campo = document.querySelector("[data-cesta-codigo-campo]");
      if (campo) {
        campo.value = "";
        campo.focus({ preventScroll: true });
      }
    });
  }

  function quitarCodigo(nombre) {
    var fuera = String(nombre || "").toUpperCase();

    return cambiarCodigos(function (lista) {
      return lista.filter(function (c) { return c !== fuera; });
    }).then(function (datos) {
      if (datos.sections) repintar(datos.sections[SECCION], datos);

      var quedan = codigosDe(datos);
      NuaSitio.anunciar(quedan.map(fraseDe).join(" · ") || resumen());

      /* El «Quitar» pulsado ya no existe. Si quedan códigos, el foco va al
         «Quitar» del primero; si no, a la pregunta del plegable. Nunca al
         campo: con el plegable cerrado no se puede enfocar, y el foco se caía
         al <body> con el cajón abierto. */
      var bloque = bloqueCodigo();
      if (!bloque) return;
      var destino = bloque.querySelector("[data-cesta-codigo-quitar]") || bloque.querySelector("summary");
      if (destino) destino.focus({ preventScroll: true });
    });
  }

  /* Un cambio de códigos cada vez: aplicar uno mientras se quita otro
     leería la misma lista y el segundo desharía lo del primero. */
  function enCola(accion) {
    if (codigoOcupado) return;
    codigoOcupado = true;
    accion()
      .catch(function (error) { mostrarError(motivo(error)); })
      .then(function () { codigoOcupado = false; });
  }

  /* ---------- Nota para regalo --------------------------------------------- */

  /* Se guarda medio segundo después de la última tecla, sólo la nota y sin
     repintar nada: repintar mientras se escribe movería el cursor.
     `notaLocal` es lo último escrito mientras no se sepa guardado; si un
     repintado llega entre medias, trae la nota vieja y manda ésta. */
  var notaTemporizador = null;
  var notaLocal = null;

  function escribirNota(campo) {
    notaLocal = campo.value;
    clearTimeout(notaTemporizador);
    notaTemporizador = setTimeout(guardarNota, 500);
  }

  function guardarNota() {
    var valor = notaLocal;
    if (valor === null) return;

    NuaSitio.pedir(NuaSitio.rutas.actualizar + ".js", { note: valor })
      .then(function () {
        if (notaLocal === valor) notaLocal = null;
        NuaSitio.anunciar(NuaSitio.textos.notaGuardada);
      })
      .catch(function (error) { mostrarError(motivo(error)); });
  }

  /* ---------- Confirmación del botón --------------------------------------- */

  /* Cambia el texto del botón a «Añadida» un momento. El aviso de verdad —el
     que se lee en voz alta— lo da anunciar(); esto es sólo para el ojo.

     Los botones que son sólo un dibujo (el «+» de la tarjeta) no tienen texto
     que cambiar: se les pone la clase es-anadido, y el CSS cambia el signo. */
  var botonConfirmado = null;

  function restaurar() {
    if (botonConfirmado) {
      if (botonConfirmado.dataset.textoOriginal) {
        botonConfirmado.textContent = botonConfirmado.dataset.textoOriginal;
      }
      botonConfirmado.classList.remove("es-anadido");
    }
    botonConfirmado = null;
  }

  function confirmar(boton) {
    if (!boton) return;
    clearTimeout(temporizador);
    if (botonConfirmado && botonConfirmado !== boton) restaurar();

    if (boton.hasAttribute("data-cesta-icono")) {
      boton.classList.add("es-anadido");
    } else {
      if (!boton.dataset.textoOriginal) boton.dataset.textoOriginal = boton.textContent;
      boton.textContent = NuaSitio.textos.anadida;
    }
    botonConfirmado = boton;

    temporizador = setTimeout(restaurar, 1600);
  }

  /* Añadir con un toque: una sugerencia del cajón o el «+» de una tarjeta.
     Mientras la petición va y viene, el botón no admite otro toque (dos
     toques rápidos eran dos unidades). No se usa disabled: un botón que se
     desactiva con el foco dentro lo pierde, y al cerrar la cesta no habría
     adónde devolverlo.

     Si falla, el motivo sale en el cajón, que se abre si estaba cerrado:
     antes el segundo «+» de una vela con una sola unidad no hacía nada en
     pantalla. */
  function anadirConUnToque(boton, id) {
    if (!boton || !id || boton.getAttribute("aria-disabled") === "true") return;
    boton.setAttribute("aria-disabled", "true");

    anadir(parseInt(id, 10), 1, boton)
      .then(function () {
        /* Si el cajón no se abre solo (ajuste de «Tienda»), el botón es la
           única señal de que ha ido bien. */
        if (window.Nua.abrirCestaAlAnadir === false && document.contains(boton)) confirmar(boton);
      })
      .catch(function (error) { mostrarError(motivo(error), boton); })
      .then(function () { boton.removeAttribute("aria-disabled"); });
  }

  /* ---------- Arranque ----------------------------------------------------- */

  function iniciar() {
    /* Todo se escucha en el documento y no en cada botón, porque repintar
       rehace el cuerpo entero: los botones de ahora no son los de dentro de un
       segundo. */
    document.addEventListener("click", function (ev) {
      if (!ev.target.closest) return;

      var paso = ev.target.closest("[data-cesta-mas],[data-cesta-menos]");
      if (paso) {
        ev.preventDefault();
        if (paso.disabled) return;
        if (paso.hasAttribute("data-cesta-mas")) {
          ajustar(paso.getAttribute("data-cesta-mas"), 1, "data-cesta-mas");
        } else {
          ajustar(paso.getAttribute("data-cesta-menos"), -1, "data-cesta-menos");
        }
        return;
      }

      var extra = ev.target.closest("[data-cesta-anadir]");
      if (extra) {
        ev.preventDefault();
        anadirConUnToque(extra, extra.getAttribute("data-cesta-anadir"));
        return;
      }

      var quitar = ev.target.closest("[data-cesta-codigo-quitar]");
      if (quitar) {
        ev.preventDefault();
        var cual = quitar.getAttribute("data-cesta-codigo-quitar");
        if (cual) enCola(function () { return quitarCodigo(cual); });
        return;
      }

      /* Un plegable que se abre cerca del borde del cuerpo (el código o la
         nota para regalo, con varias líneas en la cesta) crecía por debajo
         del borde y había que ir a buscarlo: al abrirlo con
         un toque, lo de dentro se trae a la vista. Sólo con un toque: los
         que abre el propio JavaScript al repintar no deben mover la lista. */
      var pregunta = ev.target.closest(".cesta__plegable > summary");
      if (pregunta && !pregunta.parentNode.open) {
        window.setTimeout(function () {
          var dentro = pregunta.parentNode.querySelector(".cesta__plegable-cuerpo");
          if (dentro && pregunta.parentNode.open && dentro.scrollIntoView) dentro.scrollIntoView({ block: "nearest" });
        }, 0);
      }
    });

    document.addEventListener("submit", function (ev) {
      var form = ev.target;

      /* El «+» de la tarjeta es un formulario de producto de verdad: sin
         JavaScript va a /cart/add y Shopify lleva a la cesta. Con él, se queda
         en la página y se abre el cajón. */
      if (form.hasAttribute("data-cesta-rapido")) {
        var campo = form.querySelector('[name="id"]');
        if (!campo) return;
        ev.preventDefault();
        anadirConUnToque(form.querySelector('[type="submit"]'), campo.value);
        return;
      }

      if (form.hasAttribute("data-cesta-codigo-form")) {
        ev.preventDefault();
        var texto = document.querySelector("[data-cesta-codigo-campo]");
        if (!texto || !texto.value.trim()) {
          if (texto) texto.focus({ preventScroll: true });
          return;
        }
        var valor = texto.value;
        enCola(function () { return aplicarCodigo(valor); });
      }
    });

    document.addEventListener("input", function (ev) {
      if (ev.target.hasAttribute && ev.target.hasAttribute("data-cesta-nota")) escribirNota(ev.target);
    });

    /* Al abrir el cajón se borra el aviso de error de la vez anterior, que ya
       no viene a cuento. Y el estado del código se pide la primera vez que se
       abre, no al cargar cada página: una petición menos para quien no la
       abre. Si antes ya se repintó (al añadir algo), ya está pedido. */
    document.addEventListener("nua:cajon-abierto", function (ev) {
      if (ev.target !== cajon()) return;
      limpiarError();
      if (!codigoPedido) codigo();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }

  return {
    anadir: anadir,
    poner: poner,
    ajustar: ajustar,
    abrir: abrir,
    confirmar: confirmar,
    cuenta: cuenta
  };
})();
